// extracted by mini-css-extract-plugin
export default {"dataCell":"CellWithWasLabel_dataCell__mM-k8","wasStatus":"CellWithWasLabel_wasStatus__91gyO"};